import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, TextField, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import patientsSx from './Patients.styles';
import { actions } from './Patients.redux';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Search } from '@mui/icons-material';

const PatientSearch = () => {
    const theme = useTheme();
    const sx = patientsSx(theme);
    const dispatch = useDispatch();
    const searchTerms = useSelector((state) => state.patients.searchTerms);
    const loading = useSelector((state) => state.patients.loading);
    const setSearchTerm = (key, value) => dispatch(actions.setSearchTerm(key, value));
    const handleSearch = () => dispatch(actions.search());
    const resetSearch = () => dispatch(actions.resetSearch());

    const handleChange = (e) => setSearchTerm(e.target.name, e.target.value);

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSearch();
    };

    return (
        <Box sx={sx.searchContainer}>
            <DashboardCard
                color={'green'}
                icon={<Search />}
                topContent={'Patient Search'}
                topLabel="Enter search criteria below"
                size="xl"
            >
                <form method="post" onSubmit={handleSubmit}>
                    <Grid container spacing={4}>
                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="Patient Name"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.patient_name}
                                name="patient_name"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="Client Name"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.client_name}
                                name="client_name"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                label="Breed"
                                variant="outlined"
                                fullWidth
                                value={searchTerms.patient_breed}
                                name="patient_breed"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                type="date"
                                label="Last Visit (Start)"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="outlined"
                                fullWidth
                                value={searchTerms.last_visit_start}
                                name="last_visit_start"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, lg: 12, xl: 6 }}>
                            <TextField
                                type="date"
                                label="Last Visit (End)"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="outlined"
                                fullWidth
                                value={searchTerms.last_visit_end}
                                name="last_visit_end"
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleSearch}
                                sx={sx.searchButtons}
                                disabled={loading}
                                type="submit"
                            >
                                Search
                            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                                onClick={resetSearch}
                                sx={sx.searchButtons}
                                disabled={loading}
                            >
                                Reset
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </DashboardCard>
        </Box>
    );
};

export default PatientSearch;
